export const PREFIX = 'OpenAi';
export const AZURE_PREFIX = 'Azure.OpenAi';
export const PROVIDER = PREFIX + '.Provider';
export const AZURE_ADVANCED_PREFIX = AZURE_PREFIX + '.Advanced';
export const ADVANCED_PREFIX = PREFIX + '.Advanced';

export const API_KEY = PREFIX + '.ApiKey';
export const HAS_EXISTING_API_KEY = PREFIX + '.HasExistingApiKey';

export const EMBEDDING_NAME = PREFIX + '.EmbeddingName';
export const MODEL = PREFIX + '.Model';
export const MAX_TOKENS = ADVANCED_PREFIX + '.OpenAiMaxTokens';
export const SPLIT_CHUNK_SIZE = ADVANCED_PREFIX + '.SplitChunkSize';
export const SPLIT_CHUNK_OVERLAP = ADVANCED_PREFIX + '.SplitChunkOverlap';
export const RETRIEVED_DOCUMENT_SPLIT_COUNT = ADVANCED_PREFIX + '.RetrievedDocumentSplitCount';
export const LLM_PROVIDER_TOKEN_PER_MIN = ADVANCED_PREFIX + '.LlmProviderTokenPerMin';
export const CRAWLER_TYPE = ADVANCED_PREFIX + '.CrawlerType';
export const MAXIMUM_PAGES_TO_CRAWL = ADVANCED_PREFIX + '.MaximumPagesToCrawl';
export const CONTENT_EXTRACTION_STRATEGY = ADVANCED_PREFIX + '.ContentExtractionStrategy';
export const MAXIMUM_CRAWL_DEPTH = ADVANCED_PREFIX + '.MaximumCrawlDepth';

export const AZURE_API_KEY = AZURE_PREFIX + '.ApiKey';
export const AZURE_HAS_EXISTING_API_KEY = AZURE_PREFIX + '.HasExistingApiKey';
export const AZURE_EMBEDDING_NAME = AZURE_PREFIX + '.EmbeddingName';
export const AZURE_DEPLOYMENT_NAME = AZURE_PREFIX + '.DeploymentName';
export const AZURE_RESOURCE_NAME = AZURE_PREFIX + '.ResourceName';
export const AZURE_EMBEDDING_DEPLOYMENT = AZURE_PREFIX + '.EmbeddingDeployment';
export const AZURE_MAX_TOKENS = AZURE_ADVANCED_PREFIX + '.OpenAiMaxTokens';
export const AZURE_SPLIT_CHUNK_SIZE = AZURE_ADVANCED_PREFIX + '.SplitChunkSize';
export const AZURE_SPLIT_CHUNK_OVERLAP = AZURE_ADVANCED_PREFIX + '.SplitChunkOverlap';
export const AZURE_RETRIEVED_DOCUMENT_SPLIT_COUNT =
  AZURE_ADVANCED_PREFIX + '.RetrievedDocumentSplitCount';
export const AZURE_LLM_PROVIDER_TOKEN_PER_MIN = AZURE_ADVANCED_PREFIX + '.LlmProviderTokenPerMin';
export const AZURE_CRAWLER_TYPE = AZURE_ADVANCED_PREFIX + '.CrawlerType';
export const AZURE_MAXIMUM_PAGES_TO_CRAWL = AZURE_ADVANCED_PREFIX + '.MaximumPagesToCrawl';
export const AZURE_CONTENT_EXTRACTION_STRATEGY =
  AZURE_ADVANCED_PREFIX + '.ContentExtractionStrategy';
export const AZURE_MAXIMUM_CRAWL_DEPTH = AZURE_ADVANCED_PREFIX + '.MaximumCrawlDepth';

export const MAX_TOKENS_DEFAULT_VALUE = 256;
export const SPLIT_CHUNK_SIZE_DEFAULT_VALUE = 1000;
export const SPLIT_CHUNK_OVERLAP_DEFAULT_VALUE = 128;
export const RETRIEVED_DOCUMENT_SPLIT_COUNT_DEFAULT_VALUE = 3;
export const LLM_PROVIDER_TOKEN_PER_MIN_DEFAULT_VALUE = 30000;
export const CRAWLER_TYPE_DEFAULT_VALUE = 'playwright:adaptive';
export const MAXIMUM_PAGES_TO_CRAWL_DEFAULT_VALUE = 5000;
export const CONTENT_EXTRACTION_STRATEGY_DEFAULT_VALUE = 'readableText';
export const MAXIMUM_CRAWL_DEPTH_DEFAULT_VALUE = 10;

export const MODEL_OPTIONS = [
  'gpt-4o',
  'gpt-4o-mini',
  'gpt-4-turbo',
  'gpt-4-turbo-preview',
  'gpt-4-1106-preview',
  'gpt-4-32k',
  'gpt-4',
  'gpt-3.5-turbo-instruct',
  'gpt-3.5-turbo-16k',
  'gpt-3.5-turbo',
];

export const EMBEDDING_NAME_OPTIONS = [
  'text-embedding-3-small',
  'text-embedding-3-large',
  'text-embedding-ada-002',
];

export const SUPPORTED_APIFY_CRAWLER_TYPE_OPTIONS = [
  {
    name: 'Adaptive switching between browser and raw HTTP',
    value: 'playwright:adaptive',
    tooltip: 'Fast renders JavaScript if needed. This is recommended option',
  },
  {
    name: 'Headless browser',
    value: 'playwright:firefox',
    tooltip: 'Reliable, renders JavaScript, best in avoiding blocking, but might be slow.',
  },
  {
    name: 'Raw HTTP client',
    value: 'cheerio',
    tooltip: 'Fastest crawler, but cannot render JavaScript',
  },
];

export const SUPPORTED_CONTENT_EXTRACTION_STRATEGY_OPTIONS = [
  {
    name: 'Readable text with fallback',
    value: 'readableTextIfPossible',
    tooltip:
      "Extracts the main content but falls back to the original HTML if the page doesn't appear to be an article. This is useful for websites with mixed content types.",
  },
  {
    name: 'Readable text',
    value: 'readableText',
    tooltip:
      'Extracts the main article content, removing navigation, headers, footers, and other non-essential elements. Works best for article-rich websites and blogs.',
  },
  {
    name: 'Extractus',
    value: 'extractus',
    tooltip:
      'Uses the Extractus library for content extraction. May work better than Readability on certain websites, particularly news sites or blogs with specific layouts.',
  },
  {
    name: 'None',
    value: 'none',
    tooltip:
      "Only applies basic cleaning (removing elements specified via 'Remove HTML elements' option) without any content extraction algorithm. Ideal for preserving original layout.",
  },
];
